import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Model, QueryResponse, SimilarityStatus, SimilarityStatusInfo} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const PROP_URL = `${API_URL}/Package`

function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const getPackage = (query: string,select?: string, modelstoinclude?: string): Promise<QueryResponse> => {
	const qis = query.split('&')
    let newq: Array<string> = []
    qis.map((q) => {
        if (q.startsWith('search=') && q.slice(-1) !== '=') {
            newq.push(`Name~${decodeURIComponent(q.substring('search='.length).replaceAll('+', ' '))}`)
        }
        if (q.startsWith('filter') && q.slice(-1) != "=") {
            if (q.includes('_id')) {
                const aq = capitalizeFirstLetter(q.replace('_id', 'Id').replace('filter_', '').replace('=', '*'))
                //console.log(aq)
                newq.push(aq)
            }
            else if (q.includes('strt') && !q.includes(' ')) {
                const aq = '(Date)' + capitalizeFirstLetter(q.replace('strt', '').replace('filter_', '').replaceAll('-', '.').replace('=', '>'))
                //console.log(aq)
                newq.push(aq)
            }
            else if (q.includes('ndnd') && !q.includes(' ')) {
                const aq = '(Date)' + capitalizeFirstLetter(q.replace('ndnd', '').replace('filter_', '').replaceAll('-', '.').replace('=', '<'))
                //console.log(aq)
                newq.push(aq)
            }
            else if (q.includes('Contains')) {
                const aq = capitalizeFirstLetter(q.replace('Contains','').replace('filter_', '').replace('=', '~'))
                newq.push(aq)
            }
            else if (q.includes('String')) {
                const aq = capitalizeFirstLetter(q.replace('String','').replace('filter_', '').replace('=', '_'))
                //console.log(aq)
                newq.push(aq)
            }
            else if (q.includes('stNMB')) {
                const aq = capitalizeFirstLetter(q.replace('stNMB', '').replace('filter_', '').replace('=', '>'))
                //console.log(aq)
                newq.push(aq)
            }
            else if (q.includes('enNMB')) {
                const aq = capitalizeFirstLetter(q.replace('enNMB', '').replace('filter_', '').replace('=', '<'))
                //console.log(aq)
                newq.push(aq)
            }            
            else if (q.includes('BL')) {
                const aq = capitalizeFirstLetter(q.replace('BL', '').replace('filter_', '').replace('=', '*'))
                //console.log(aq)
                newq.push(aq)
            }
        }
    })

    const newqstring = newq.filter((f) => f).join('|')
	
	let mti = "";
    if (modelstoinclude != undefined && modelstoinclude != "") {
        mti = "&modelstoinclude=" + modelstoinclude
    }
	let sti = "";
	if(select != undefined && select != "")
	{
		sti = "&select=" + select
	}

  const apiQuery = qis.filter((q) => !q.startsWith('search=')).join('&')
  return axios.get(`${PROP_URL}/getAll/${newqstring}?${apiQuery}${mti}${sti}`).then((d: AxiosResponse<QueryResponse>) => d.data)
}

const listPackage = async (select?: string, modelstoinclude?: string): Promise<any> => {
    let mti = "";
    if (modelstoinclude != undefined) {
        mti = "&modelstoinclude=" + modelstoinclude
    }
        return await axios.get(`${PROP_URL}/getAll?page=1&items_per_page=99999${mti}&select=${select}`).then((res: AxiosResponse) => {
            return res.data
})    
}

export const fetchSimilarityResults = (packageId: number, minCosine: number): Promise<any> => {
    return axios.post(`${API_URL}/Custom/AnalyzePackageSimilarity?packageId=${packageId}&minCosine=${minCosine}`)
        .then((response: AxiosResponse<any>) => response.data);
}

export const fetchPackageSimilarityStatuses = (packageIds: number[]): Promise<Record<number, SimilarityStatusInfo>> => {
    return axios
        .post(`${API_URL}/Custom/GetPackageSimilarityStatuses`, packageIds)
        .then((response: AxiosResponse<Record<number, SimilarityStatusInfo>>) => response.data)
}

export type TriggerSimilarityResponse = {
    status: SimilarityStatus
    message?: string
}

export const triggerPackageSimilarityAnalysis = (packageId: number, minCosine: number): Promise<TriggerSimilarityResponse> => {
    return axios
        .post(`${API_URL}/Custom/TriggerPackageSimilarityAnalysis?packageId=${packageId}&minCosine=${minCosine}`)
        .then((response: AxiosResponse<TriggerSimilarityResponse>) => response.data)
}

export const SendEmailToWriterOrReviewer = (writerorreviewer:number, packageId: number, message: string): Promise<QueryResponse> => {
    return axios.post(`${API_URL}/Custom/SendEmailToWriterOrReviewer?writerorreviewer=${writerorreviewer}&message=${message}&packageId=${packageId}`)
        .then((response: AxiosResponse<QueryResponse>) => response.data);
}

export const SendEmailToWriterAndReviewers = (packageId: number): Promise<QueryResponse> => {
    return axios.post(`${API_URL}/Custom/SendEmailToWriterAndReviewers?packageId=${packageId}`)
        .then((response: AxiosResponse<QueryResponse>) => response.data);
}

const updatePackageQuestionsStatus = (packageId: number, statusId: number): Promise<void> => {
    return axios
        .post(`${API_URL}/Custom/UpdatePackageQuestionsStatus?packageId=${packageId}&statusId=${statusId}`)
        .then(() => { })
}

const updatePackageQuestionsBulk = (packageId: number, payload: {writerId?: number; reviewerId?: number; watcherId?: number; statusId?: number}): Promise<void> => {
    const params = new URLSearchParams({packageId: packageId.toString()})

    if (payload.writerId) {
        params.append('writerId', payload.writerId.toString())
    }

    if (payload.reviewerId) {
        params.append('reviewerId', payload.reviewerId.toString())
    }

    if (payload.watcherId) {
        params.append('watcherId', payload.watcherId.toString())
    }

    if (payload.statusId) {
        params.append('statusId', payload.statusId.toString())
    }

    return axios
        .post(`${API_URL}/Custom/UpdatePackageQuestionsBulk?${params.toString()}`)
        .then(() => {})
}

const getPackageById = (id: ID): Promise<Model | undefined> => {
  return axios
    .get(`${PROP_URL}/${id}`)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response as any)
}

const createPackage = (prop: Model): Promise<any | undefined> => {
  return axios
    .put(PROP_URL, prop)
}

export type PackageQuestionPreparationResult = {
    success: boolean
    returnValue: number
    message: string
}

export const customExecuteInsertQuestions = (): Promise<PackageQuestionPreparationResult> => {
    return axios.post(`${API_URL}/Custom/ExecuteInsertQuestions`)
        .then((response: AxiosResponse<PackageQuestionPreparationResult>) => response.data);
}

const updatePackage = (prop: Model): Promise<Model | undefined> => {
  return axios
    .post(`${PROP_URL}/${prop.id}`, prop)
    .then((response: AxiosResponse<Response<Model>>) => response.data)
    .then((response: Response<Model>) => response.data)
}

const deletePackage = (propId: ID): Promise<void> => {
  return axios.delete(`${PROP_URL}/${propId}`).then(() => {})
}

const deleteSelectedPackage = (propIds: Array<ID>): Promise<void> => {
  const requests = propIds.map((id) => axios.delete(`${PROP_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getPackage, deletePackage, deleteSelectedPackage, getPackageById, createPackage, updatePackage, listPackage, updatePackageQuestionsStatus, updatePackageQuestionsBulk}
